import { render, staticRenderFns } from "./QuillLikeEditor.vue?vue&type=template&id=838a62a2"
import script from "./QuillLikeEditor.vue?vue&type=script&lang=js"
export * from "./QuillLikeEditor.vue?vue&type=script&lang=js"
import style0 from "./QuillLikeEditor.vue?vue&type=style&index=0&id=838a62a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports